export function detectDeviceProfile() {
    const profile = {
        lowMemory: false,
        lowEndGPU: false,
        lowEndCPU: false,
        prefersReducedMotion: false,
        resolutionScale: 1,
        enableShadows: true,
        enablePostFX: true,
        loadHeavyModels: true,
        maxTextureSize: 4096     // dynamically lowered later
    };

    // 1. Memory check
    if (navigator.deviceMemory && navigator.deviceMemory < 2) {
        profile.lowMemory = true;
    }

    // 2. GPU check using WebGL capabilities
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

    if (gl) {
        const maxTex = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        const maxTexUnits = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);

        if (maxTex < 4096) {
            profile.lowEndGPU = true;
            profile.maxTextureSize = 2048;
        }

        if (maxTexUnits < 8) {
            profile.lowEndGPU = true;
        }
    } else {
        // No WebGL at all = absolute low-end fallback
        return {
            noWebGL: true
        };
    }

    // 3. Reduced motion user preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        profile.prefersReducedMotion = true;
    }

    // 4. CPU heuristic via hardwareConcurrency
    if (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) {
        profile.lowEndCPU = true;
    }

    // --- FINAL DECISION MATRIX ---
    if (profile.lowMemory || profile.lowEndGPU) {
        profile.resolutionScale = 0.5;
        profile.enableShadows = false;
        profile.enablePostFX = false;
        profile.loadHeavyModels = false;
        profile.maxTextureSize = 2048;
    }

    if (profile.lowEndCPU) {
        profile.enablePostFX = false;
        profile.resolutionScale = 0.75;
    }

    if (profile.prefersReducedMotion) {
        profile.enablePostFX = false;
    }

    return profile;
}
